export default {
  "quot": "\u0022",
  "amp": "\u0026",
  "lt": "\u003C",
  "gt": "\u003E",
  "nbsp": "\u00A0"
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/share/defaultEntityMap.js